import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Compass } from "lucide-react";
import { useLang } from "../lib/i18n";
import { Reveal } from "./Reveal";
import { LogoMark } from "./Logo";

const EMAIL = "Koraniconstructiongroup@gmail.com";

export const Contact = () => {
  const { t } = useLang();
  const c = t.contact;
  const rows = [
    { icon: Phone, label: c.phone, value: "+30 698 765 4456", href: "tel:+306987654456", id: "phone" },
    { icon: Mail, label: c.email, value: EMAIL, href: `mailto:${EMAIL}`, id: "email" },
    { icon: MapPin, label: c.address, value: "Ελευθερίου Βενιζέλου 12, Κιλκίς", id: "address" },
    { icon: Compass, label: c.area, value: c.areaVal, id: "area" },
  ];
  return (
    <section id="contact" className="relative py-24 sm:py-36" data-testid="contact-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <Reveal>
          <p className="eyebrow mb-5">{c.eyebrow}</p>
          <h2 className="font-display text-5xl font-black uppercase leading-[0.9] tracking-[-0.03em] text-white sm:text-7xl lg:text-[8rem]" data-testid="contact-title">{c.title}</h2>
        </Reveal>
        <div className="mt-16 grid grid-cols-1 border-t border-emerald-500/20 sm:grid-cols-2 lg:grid-cols-4">
          {rows.map((r, i) => {
            const Inner = r.href ? "a" : "div";
            return (
              <Reveal key={r.id} delay={i * 0.08} className="border-b border-emerald-500/10 py-8 sm:pr-6">
                <Inner href={r.href} className="group block" data-testid={`contact-${r.id}`}>
                  <r.icon className="h-5 w-5 text-[#00E676]" />
                  <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-400">{r.label}</p>
                  <p className="mt-2 break-all text-base font-semibold text-white transition-colors group-hover:text-[#00E676] sm:text-lg">{r.value}</p>
                </Inner>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="border-t border-emerald-500/15 bg-[#050706]" data-testid="footer">
      <div className="mx-auto flex max-w-[1400px] flex-col gap-6 px-5 py-10 sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <div className="flex items-center gap-3">
          <LogoMark className="h-8 w-8" />
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">© {new Date().getFullYear()} KORANI GROUP · {t.footer.rights}</span>
        </div>
        <div className="flex items-center gap-6">
          <Link to="/privacy-policy" className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400 hover:text-[#00E676]" data-testid="footer-privacy-link">Πολιτική Απορρήτου</Link>
          <Link to="/admin" className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400 hover:text-[#00E676]" data-testid="footer-admin-link">{t.footer.admin}</Link>
        </div>
      </div>
    </footer>
  );
};
